var path = 'components/icon/icon.template.html';
var html = "<span class=smb-app__icon ng-show=\"vm.iconData && !vm.iconData.isBinary\" ng-bind-html=vm.iconData.data></span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/icon/icon.template.html
// module id = 190
// module chunks = 1